<div class="d-flex flex-row col-12 justify-content-between" style="height: 70vh;">
  <div class="col-6 p-4" style="    max-height: 70vh; overflow: auto;">
    <h1 class="text-center">{{notifications.length}} NOTIFICACIONES</h1>
    <div class="card-notification-container">
      <div class="card-notification mat-elevation-z5 mb-3" [style.background]="item.color"
        *ngFor="let item of notifications" (click)="handlerNotification(item)">
        <h5 class="m-1">{{item.title}}</h5>
        <h6 class="m-1">Descripción: {{item.description}}</h6>
      </div>
    </div>
  </div>

  <div class="col-1" class="border-right-card mt-3" style="height: 65vh; margin-top: 5vh;">
  </div>

  <div class="col-5 d-flex flex-column justify-content-center p-4">

    <div class="d-flex flex-row border-bottom-card h-25-vh align-items-center">
      <div class="card-data border-right-card " (click)="router.navigate(['/mantenimiento/ejecucion_OT'])">
        <h3 class="text-center text-data">Órdenes de mantenimiento en ejecución</h3>
        <p class="number-data">{{dataDashboard.ejecutionOt}}</p>
      </div>
      <div class="card-data" (click)="router.navigate(['/mantenimiento/orden_trabajo'])">
        <h3 class="text-center text-data">Órdenes de mantenimiento por autorizar</h3>
        <p class="number-data">{{dataDashboard.ot}}</p>
      </div>
    </div>

    <div class="d-flex flex-row border-bottom-card h-25-vh align-items-center">
      <div class="card-data border-right-card" (click)="router.navigate(['/mantenimiento/calendario'])">
        <h3 class="text-center text-data">Actividades programadas para hoy</h3>
        <p class="number-data">{{dataDashboard.mPre}}</p>
      </div>
      <div class="card-data" (click)="router.navigate(['/combustible/autoriza_comb'])">
        <h3 class="text-center text-data">Órdenes de combustible en ejecución</h3>
        <p class="number-data">{{dataDashboard.ejecutionOC}}</p>
      </div>
    </div>

    <div class="d-flex flex-row h-25-vh align-items-center">
      <div class="card-data border-right-card"
        (click)="redirect('/mantenimiento/preoperacionales/historico?filterToday=true')">
        <h3 class="text-center text-data">Inspecciones realizadas para {{today}}</h3>
        <p class="number-data">{{dataDashboard.inspections}}</p>
      </div>
      <div class="card-data" (click)="refreshDashboard()">
        <h3 class="text-center text-data">Recargar dashboard</h3>
        <mat-icon class="number-data d-flex align-items-center justify-content-center p-3">refresh</mat-icon>
      </div>
    </div>

  </div>
</div>
